const config = {
    DOMAIN: process.env.REACT_APP_REST_API_LOCATION || '',
    ROUTER_BASE_NAME: process.env.REACT_APP_ROUTER_BASE_NAME,
}
export default config
